interface IColorProps {
  fontColor: string;
  fontColorDark: string;
  backgroundColor: string;
  panelBackgroundColor: string;
  panelBgAltColor: string;
  iconColor: string;
  greyBorder: string;
  greyText: string;
  dangerColor: string;
  successColor: string;
  logoColor: string;
  skyBlueColor: string;
  primaryBtnBgColor: string;
  primaryBtnTxtColor: string;
  borderColor: string;
  linkColor: string;
  contentLoaderBg: string;
  contentLoaderFg: string;
  menuItem: string;
  menuItemSelected: string;
  rowSelected: string;
  disabledColor: string;
  materialGreen: string;
  materialRed: string;
  materialOrange: string;
  inputBorder: string;
  inputDisabledBorder: string;
  inputLabel: string;
  inputDisabledLabel: string;
  inputColor: string;
  chipSuccess: string;
  chipError: string;
  chipSuccessBackground: string;
  chipErrorBackground: string;
  chipPrimary: string;
  chipPrimaryBackground: string;

  // Backgrounds
  darkBackground: string;
  menuItemHoverBackground: string;
  menuItemSelectedBackground: string;
  menuItemFocusBackground: string;
  menuItemDisabledBackground: string;

  // Borders
  defaultBorderColor: string;
  hoverBorderColor: string;
  focusedBorderColor: string;
  disabledBorderColor: string;
  errorBorderColor: string;

  // Text Colors
  inputTextDefault: string;
  inputTextFocused: string;
  inputTextDisabled: string;
  inputTextError: string;

  // Label Colors
  labelDefault: string;
  labelFocused: string;
  labelDisabled: string;
  labelError: string;

  // Adornments and Icons
  adornmentText: string;
  selectIcon: string;

  // Menu Items
  menuItemText: string;
  menuItemDisabledText: string;
}

interface IColors {
  [light: string]: IColorProps;
  dark: IColorProps;
}

const COLORS: IColors = {
  light: {
    fontColor: '#3e424e',
    fontColorDark: '#000',
    backgroundColor: '#F3F2EF',
    panelBackgroundColor: '#fff',
    panelBgAltColor: '#fcfcfc',
    iconColor: '#3e424e',
    greyBorder: '#96A7AF',
    greyText: '#909090',
    dangerColor: '#E91E63',
    successColor: '#4CAF50',
    logoColor: '#525252',
    skyBlueColor: '#03a9f4',
    primaryBtnBgColor: '#525252',
    primaryBtnTxtColor: '#fff',
    borderColor: '#dddddb',
    linkColor: '#013a54',
    contentLoaderBg: '#f3f3f3',
    contentLoaderFg: '#ecebeb',
    menuItem: '#fff',
    menuItemSelected: '#dbdad7',
    rowSelected: '#afe5ff',
    disabledColor: '#dbdbdb',
    materialGreen: '#4CAF50',
    materialRed: '#F44336',
    materialOrange: '#FF5722',
    inputLabel: 'rgba(0, 0, 0, 0.6)',
    inputDisabledLabel: 'rgba(0, 0, 0, 0.38)',
    inputBorder: 'rgba(0, 0, 0, 0.26)',
    inputDisabledBorder: 'rgba(0, 0, 0, 0.23)',
    inputColor: 'rgba(0, 0, 0, 0.87)',
    chipSuccess: 'rgb(34, 154, 22)',
    chipSuccessBackground: 'rgba(84, 214, 44, 0.16)',
    chipError: 'rgb(183, 33, 54)',
    chipErrorBackground: 'rgba(255, 72, 66, 0.16)',
    chipPrimary: 'rgb(12, 83, 183)',
    chipPrimaryBackground: 'rgba(24, 144, 255, 0.16)',
    // Backgrounds
    darkBackground: "#fff",
    menuItemHoverBackground: "rgba(0, 0, 0, 0.08)",
    menuItemSelectedBackground: "rgba(63, 81, 181, 0.12)",
    menuItemFocusBackground: "rgba(63, 81, 181, 0.24)",
    menuItemDisabledBackground: "rgba(0, 0, 0, 0.12)",

    // Borders
    defaultBorderColor: "rgba(0, 0, 0, 0.23)",
    hoverBorderColor: "rgba(0, 0, 0, 0.5)",
    focusedBorderColor: "#3f51b5",
    disabledBorderColor: "rgba(0, 0, 0, 0.12)",
    errorBorderColor: "#f44336",

    // Text Colors
    inputTextDefault: "rgba(0, 0, 0, 0.87)",
    inputTextFocused: "#3f51b5",
    inputTextDisabled: "rgba(0, 0, 0, 0.38)",
    inputTextError: "#f44336",

    // Label Colors
    labelDefault: "rgba(0, 0, 0, 0.54)",
    labelFocused: "#3f51b5",
    labelDisabled: "rgba(0, 0, 0, 0.38)",
    labelError: "#f44336",

    // Adornments and Icons
    adornmentText: "rgba(0, 0, 0, 0.54)",
    selectIcon: "rgba(0, 0, 0, 0.54)",

    // Menu Items
    menuItemText: "rgba(0, 0, 0, 0.87)",
    menuItemDisabledText: "rgba(0, 0, 0, 0.38)",
  },
  dark: {
    fontColor: '#eaeaea',
    fontColorDark: '#fff',
    backgroundColor: '#15202B',
    panelBackgroundColor: '#253341',
    panelBgAltColor: '#1f2a36',
    iconColor: '#d9d9d9',
    greyBorder: '#96A7AF',
    greyText: '#909090',
    dangerColor: '#E91E63',
    successColor: '#4CAF50',
    logoColor: '#525252',
    skyBlueColor: '#03a9f4',
    primaryBtnBgColor: '#525252',
    primaryBtnTxtColor: '#fff',
    borderColor: '#121a21',
    linkColor: '#03A9F4',
    contentLoaderBg: '#19212b',
    contentLoaderFg: '#324155',
    menuItem: '#253341',
    menuItemSelected: '#15202B',
    rowSelected: '#afe5ff',
    disabledColor: '#4f5860',
    materialGreen: '#4CAF50',
    materialRed: '#F44336',
    materialOrange: '#FF5722',
    inputLabel: 'rgba(255, 255, 255, 0.7)',
    inputDisabledLabel: 'rgba(255, 255, 255, 0.5)',
    inputBorder: 'rgba(255, 255, 255, 0.3)',
    inputDisabledBorder: 'rgba(255, 255, 255, 0.23)',
    inputColor: 'rgb(255, 255, 255)',
    chipSuccessBackground: 'rgb(84, 214, 44)',
    chipSuccess: 'rgb(33, 43, 54)',
    chipErrorBackground: 'rgb(255, 72, 66)',
    chipError: 'rgb(255, 255, 255)',
    chipPrimary: 'rgb(255, 255, 255)',
    chipPrimaryBackground: 'rgb(24, 144, 255)',
    // Backgrounds
    darkBackground: "#333",
    menuItemHoverBackground: "rgba(255, 255, 255, 0.1)",
    menuItemSelectedBackground: "rgba(63, 81, 181, 0.12)",
    menuItemFocusBackground: "rgba(63, 81, 181, 0.24)",
    menuItemDisabledBackground: "rgba(255, 255, 255, 0.12)",

    // Borders
    defaultBorderColor: "rgba(255, 255, 255, 0.23)",
    hoverBorderColor: "rgba(255, 255, 255, 0.5)",
    focusedBorderColor: "#3f51b5",
    disabledBorderColor: "rgba(255, 255, 255, 0.12)",
    errorBorderColor: "#f44336",

    // Text Colors
    inputTextDefault: "rgba(255, 255, 255, 0.87)",
    inputTextFocused: "#3f51b5",
    inputTextDisabled: "rgba(255, 255, 255, 0.38)",
    inputTextError: "#f44336",

    // Label Colors
    labelDefault: "rgba(255, 255, 255, 0.7)",
    labelFocused: "#3f51b5",
    labelDisabled: "rgba(255, 255, 255, 0.5)",
    labelError: "#f44336",

    // Adornments and Icons
    adornmentText: "rgba(255, 255, 255, 0.7)",
    selectIcon: "rgba(255, 255, 255, 0.7)",

    // Menu Items
    menuItemText: "rgba(255, 255, 255, 0.87)",
    menuItemDisabledText: "rgba(255, 255, 255, 0.38)",
  },
};

export default COLORS;
